import { RunState } from "../state/RunState";
import {
  BASE_POINT,
  COMBO_MULT_MIN,
  COMBO_MULT_MAX,
  COMBO_INCREMENT,
  EMA_ALPHA,
  SPEED_FAST_MS,
  SPEED_SLOW_MS,
  ACCURACY_THRESHOLDS,
  ACCURACY_FALLBACK,
  COMPLETION_BONUS_BASE,
  COMPLETION_BONUS_LENGTH_DIVISOR,
  STAGE_CONFIGS,
  DEBUG,
} from "../config";

/** スコアリングシステム（Scene内に式を書かない） */
export class ScoringSystem {
  /** ヒット時の処理 */
  onHit(state: RunState, nowMs: number): void {
    // combo更新
    state.combo++;
    state.comboMult = Math.min(
      COMBO_MULT_MAX,
      Math.max(COMBO_MULT_MIN, 1.0 + COMBO_INCREMENT * state.combo)
    );
    if (state.comboMult > state.maxComboMult) {
      state.maxComboMult = state.comboMult;
    }

    // speedFactor計算
    let speedFactor = 1.0;
    if (state.hits > 0 && state.lastHitAtMs > 0) {
      const intervalMs = nowMs - state.lastHitAtMs;
      state.emaHitIntervalMs =
        EMA_ALPHA * intervalMs + (1 - EMA_ALPHA) * state.emaHitIntervalMs;
      const t = Math.max(
        0,
        Math.min(1, (SPEED_SLOW_MS - state.emaHitIntervalMs) / (SPEED_SLOW_MS - SPEED_FAST_MS))
      );
      speedFactor = 1.0 + 0.5 * t;
    }

    // hits更新（speedFactor計算後に更新）
    state.hits++;
    state.lastHitAtMs = nowMs;

    // accuracyFactor
    const accuracyFactor = this.getAccuracyFactor(state.misses);

    // stageFactor
    const stageConfig = STAGE_CONFIGS[state.stage];
    const stageFactor = stageConfig.stageFactor;

    // deltaScore
    const deltaScore = Math.round(
      BASE_POINT * state.comboMult * speedFactor * accuracyFactor * stageFactor
    );
    state.score += deltaScore;

    if (DEBUG) {
      console.log(
        `[Score] hit combo=${state.combo} mult=${state.comboMult.toFixed(1)} speed=${speedFactor.toFixed(2)} acc=${accuracyFactor} stage=${stageFactor} delta=${deltaScore} total=${state.score}`
      );
    }
  }

  /** ミス時の処理 */
  onMiss(state: RunState): void {
    state.combo = 0;
    state.comboMult = COMBO_MULT_MIN;
    state.misses++;

    if (DEBUG) {
      console.log(`[Score] miss misses=${state.misses}`);
    }
  }

  /** 文完走ボーナス */
  onSentenceCompleted(state: RunState): void {
    const stageConfig = STAGE_CONFIGS[state.stage];
    const bonus = Math.round(
      COMPLETION_BONUS_BASE *
        stageConfig.stageFactor *
        (state.sentence.length / COMPLETION_BONUS_LENGTH_DIVISOR)
    );
    state.score += bonus;

    if (DEBUG) {
      console.log(`[Score] completion bonus=${bonus} total=${state.score}`);
    }
  }

  private getAccuracyFactor(misses: number): number {
    for (const threshold of ACCURACY_THRESHOLDS) {
      if (misses <= threshold.maxMisses) {
        return threshold.factor;
      }
    }
    return ACCURACY_FALLBACK;
  }
}
